import React from 'react';
import { TPA_EXPERIMENTS } from '@wix/pricing-plans-common/experiments';
import { WidgetProps, useEnvironment, useExperiments } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';
import { CommonProps, ListProps } from '../../../types/common';
import { PlanListSettingsAdapter } from '../../PlanList/PlanListSettingsAdapter';
import settingsParams from '../settingsParams';
import stylesParams from '../stylesParams';
import List from './List';
import { Modal } from './Modal';
import { WidgetContext } from './WidgetContext';

const LazyListV2 = loadable(() => import('./ListV2'));

type PlanListPageWidgetProps = CommonProps & ListProps;

const PlanListPageWidget: React.FC<WidgetProps<PlanListPageWidgetProps>> = (props) => {
  const { navigateToHomePage } = props;
  const { experiments } = useExperiments();
  const { isMobile } = useEnvironment();
  const width = props.host.dimensions.width ?? (isMobile ? 320 : 980);

  const emptyState = React.useMemo(
    () => ({ isInWidget: false, onClick: () => navigateToHomePage(), subtitle: props.plansErrorMessage }),
    [navigateToHomePage, props.plansErrorMessage],
  );

  return (
    <WidgetContext
      settingsAdapterClass={PlanListSettingsAdapter}
      settingsParams={settingsParams}
      stylesParams={stylesParams}
      locale={props.locale}
      width={width}
    >
      {experiments.enabled(TPA_EXPERIMENTS.PLAN_LIST_V2) ? (
        <LazyListV2 emptyState={emptyState} {...props} />
      ) : (
        <List emptyState={emptyState} {...props} />
      )}
      <Modal modal={props.modal} metaSiteId={props.metaSiteId} biUpgradeReferralClick={props.biUpgradeReferralClick} />
    </WidgetContext>
  );
};

export default PlanListPageWidget;
